import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=356a414c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=356a414c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a414c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356a414c')) {
      api.createRecord('356a414c', component.options)
    } else {
      api.reload('356a414c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=356a414c&scoped=true&", function () {
      api.rerender('356a414c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hqCLQZHr4RaJ/JS/comp/DocBox.vue"
export default component.exports